import PropertyDetailLayout from './PropertyDetailLayout.vue';

export default PropertyDetailLayout;